<template>
  <LicenseWarningBanner v-if="isAuthenticated" />
  <router-view v-slot="{ Component }">
    <KeepAlive :include="['DashboardView']">
      <component :is="Component" />
    </KeepAlive>
  </router-view>
</template>

<script setup>
import LicenseWarningBanner from '@shared/components/LicenseWarningBanner.vue'
import { useAuth } from '@shared/composables/useAuth.js'

const { isAuthenticated } = useAuth()
</script>
